module.exports = __webpack_public_path__ + "ripple_bg-c900e1202401a1a285ea8454ccefd24a.svg";